var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v("Child1")]),_c('compSix'),_vm._v(" "+_vm._s(_vm.localHui)+" "),_c('button',{on:{"click":_vm.incCounter}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }